const status = [
  {
    id: "On-going",
    name: "common.on_going"
  },
  {
    id: "Concluded",
    name: "common.concluded"
  },
  {
    id: "Pending",
    name: "common.pending"
  }
];

const TEACHER_ASSIGNMENTS = {
  PRIMARY: "Primary Teacher",
  SECONDARY: "Secondary Teacher"
};

export { status, TEACHER_ASSIGNMENTS };
